import { useEffect } from 'react';
import { localStorageBridge } from 'shared/src/utils';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';
import type { RecentKeywordItem } from '../SearchHelper.page';

export const useLogViewEvent = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  useEffect(() => {
    const logEvent = async () => {
      const stored = await localStorageBridge.getString('KEY_RECENT_SEARCH');
      const parsed: RecentKeywordItem[] = stored ? JSON.parse(stored) : [];
      const items = parsed.filter(item => !item.is_delete);

      logAnalyticsEvent({
        name: 'VIEW_SEARCH',
        channel: ['firebase', 'amplitude', 'ablylog'],
        analytics: {
          HAS_BANNER: items.length === 0 ? '1' : '0',
        },
      });
    };

    logEvent();
  }, [logAnalyticsEvent]);
};
